export default "__VITE_ASSET__bd7d7614__"